const getColumns=(columns, colsCfg)=>columns.map(col=>({...col,...colsCfg?.find(({dataIndex})=>dataIndex===col.dataIndex)}));

export default getColumns;
